export default {
    ACTIVE: 1,
    BLOCK: 0,
    PENDING: 2,
    REMOVED: 3,
    REMOVED_WHEN_PENDING: 6,

    isRemoved(status) {
        return status === this.REMOVED || status === this.REMOVED_WHEN_PENDING
    }
}
